import { render, staticRenderFns } from "./CompetenceItem.vue?vue&type=template&id=337c6348&scoped=true"
import script from "./CompetenceItem.vue?vue&type=script&lang=js"
export * from "./CompetenceItem.vue?vue&type=script&lang=js"
import style0 from "./CompetenceItem.vue?vue&type=style&index=0&id=337c6348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337c6348",
  null
  
)

export default component.exports